<template>
  <div class="content-cell">
    <div class="content-cell-item flex-r-cc">
      {{ content }}
    </div>
    <div class="line"></div>
  </div>
</template>
<script>
export default {
  name: 'content-cell',
  props: ['content'],
}
</script>
<style lang="scss">
.content-cell {
  width: 166px;
  font-size: 12px;
  color: #29bdb9;
  text-align: center;
  //box-shadow: 0px 4px 15px #edf5f5;
  .content-cell-item {
    height: 60px;
  }
  .line {
    width: 150px;
    height: 1px;
    background-color: #d3f1f1;
    margin: auto;
  }
}
@media screen and (max-width: 600px) {
  .content-cell {
    width: 100%;
    .line {
      width: initial;
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .cell-double {
    width: 92%;
    .content-cell {
      width: 100%;
      .line {
        width: initial;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tariff/title-type/content-cell.vue